var chunkMapping = {
	"6179": [
		62797,
		75228,
		88296,
		93947
	],
	"7126": [
		4446,
		17418,
		49394,
		85646
	],
	"7293": [
		7293
	],
	"8165": [
		29870,
		31930,
		47538,
		51113,
		82893,
		89982
	]
};
var idToExternalAndNameMapping = {
	"4446": [
		"default",
		"./utils/common",
		4089
	],
	"7293": [
		"default",
		"./AppLoader",
		4089
	],
	"17418": [
		"default",
		"./appSlice",
		4089
	],
	"29870": [
		"default",
		"./helpers/PageTitle",
		4089
	],
	"31930": [
		"default",
		"./components/CustomNoDataOverlay",
		4089
	],
	"47538": [
		"default",
		"./helpers/CustomModalStyle",
		4089
	],
	"49394": [
		"default",
		"./store",
		4089
	],
	"51113": [
		"default",
		"./helpers/PageContainer",
		4089
	],
	"62797": [
		"default",
		"./components/ColumnSelectorStyle",
		4089
	],
	"75228": [
		"default",
		"./utils/constants",
		4089
	],
	"82893": [
		"default",
		"./helpers/PageSubHeader",
		4089
	],
	"85646": [
		"default",
		"./headerSlice",
		4089
	],
	"88296": [
		"default",
		"./helpers/CustomSearch",
		4089
	],
	"89982": [
		"default",
		"./helpers/Breadcrumb",
		4089
	],
	"93947": [
		"default",
		"./helpers/CustomDropDownSelect",
		4089
	]
};
var idToRemoteMap = {
	"4446": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 4089
		}
	],
	"7293": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 4089
		}
	],
	"17418": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 4089
		}
	],
	"29870": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 4089
		}
	],
	"31930": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 4089
		}
	],
	"47538": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 4089
		}
	],
	"49394": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 4089
		}
	],
	"51113": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 4089
		}
	],
	"62797": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 4089
		}
	],
	"75228": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 4089
		}
	],
	"82893": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 4089
		}
	],
	"85646": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 4089
		}
	],
	"88296": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 4089
		}
	],
	"89982": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 4089
		}
	],
	"93947": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 4089
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}